(function () {
  function getModal() {
    return document.getElementById('LocalizationModal');
  }

  function closeAllSelects(modal) {
    modal.querySelectorAll('[data-loc-options]').forEach((panel) => (panel.hidden = true));
    modal.querySelectorAll('[data-loc-trigger]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  }

  function openModal() {
    const modal = getModal();
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('overflow-hidden-mobile', 'overflow-hidden-tablet');
    requestAnimationFrame(() => modal.classList.add('localization-modal--active'));
  }

  function closeModal() {
    const modal = getModal();
    if (!modal) return;
    modal.classList.remove('localization-modal--active');
    closeAllSelects(modal);
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
    setTimeout(() => {
      modal.hidden = true;
    }, 250);
  }

  function initSelect(modal, select) {
    const trigger = select.querySelector('[data-loc-trigger]');
    const optionsPanel = select.querySelector('[data-loc-options]');
    const valueEl = select.querySelector('[data-loc-value]');
    const hiddenInput = select.parentElement.querySelector('[data-loc-input]');
    const options = select.querySelectorAll('[data-loc-option]');
    const currencyDisplay = select.parentElement.querySelector('[data-loc-currency-display]');
    if (!trigger || !optionsPanel || !valueEl || !hiddenInput) return;

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = !optionsPanel.hidden;
      closeAllSelects(modal);
      optionsPanel.hidden = isOpen;
      trigger.setAttribute('aria-expanded', (!isOpen).toString());
    });

    options.forEach((option) => {
      option.addEventListener('click', (event) => {
        event.stopPropagation();
        hiddenInput.value = option.dataset.value;
        valueEl.innerHTML = option.innerHTML;

        options.forEach((o) => o.classList.remove('loc-select__option--selected'));
        option.classList.add('loc-select__option--selected');

        if (currencyDisplay && option.dataset.currencyCode) {
          currencyDisplay.textContent = `${option.dataset.currencyCode} (${option.dataset.currencySymbol})`;
        }

        optionsPanel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init() {
    const modal = getModal();
    if (!modal || modal.dataset.locInit === 'true') return;
    modal.dataset.locInit = 'true';

    const overlay = modal.querySelector('[data-loc-modal-overlay]');
    const closeButton = modal.querySelector('[data-loc-modal-close]');

    if (overlay) overlay.addEventListener('click', closeModal);
    if (closeButton) closeButton.addEventListener('click', closeModal);

    modal.querySelectorAll('[data-loc-select]').forEach((select) => initSelect(modal, select));
  }

  // Delegated, always-registered listener: works even if the modal itself
  // hasn't initialized yet, and covers triggers added anywhere/anytime.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-loc-modal-open]');
    if (opener) {
      event.preventDefault();
      init();
      openModal();
      return;
    }

    if (!event.target.closest('[data-loc-select]')) {
      const modal = getModal();
      if (modal) closeAllSelects(modal);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.code !== 'Escape') return;
    const modal = getModal();
    if (modal && !modal.hidden) closeModal();
  });

  document.addEventListener('localization-modal:open', () => {
    init();
    openModal();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
